import { Grid, Tab, Table, TableBody, Typography } from "@mui/material";
import * as api from "api/Core";
import { DefaultListParameters } from "assets/appConfig";
import { AppMessageBox } from "components/AppMessageBox";
import { AppTabs } from "components/AppTabs";
import IconButtonCancel from "components/Buttons/IconButtonCancel";
import IconButtonDownload from "components/Buttons/IconButtonDownload";
import { SpinnerIndicator } from "components/CallServer";
import { exportToXLSX } from "components/ExportToExcel";
import MuiMessageBox from "components/MuiExtras/MessageBox/MuiMessageBox";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiPagination from "components/MuiExtras/MuiPagination";
import MuiMuted from "components/MuiExtras/Typography/MuiMuted";
import MuiReverse from "components/MuiExtras/Typography/MuiReverse";
import { Formaters } from "lib/Formarters";
import HtmlUtils from "lib/HtmlUtils";
import LibUtils from "lib/LibUtils";
import { DashboardCourseAnalysisDetailColumn, DashboardCourseAnalysisSummaryColumn, DashboardGraphModel, DashboardPublicationModel, PagedResult } from "models/ApiModels";
import moment from "moment";
import * as React from "react";
import { WithTranslation } from "react-i18next";
import { RenderGraphGmtInfo } from "views/Dashboards/components/RenderGraphGmtInfo";
import { RenderLineGraph } from "views/Dashboards/components/RenderLineGraph";
import { RenderPublicationModelList } from "views/Dashboards/components/RenderPublicationModelList";
import UserListDrawer from "views/Dashboards/components/UserListDrawer";
import { DashboardCourseAnalysisGraphPeriod, DashboardCourseAnalysisListPeriod, IDashboardCourseAnalysisGraphProps, IDashboardCourseAnalysisGraphState, IDashboardCourseAnalysisListProps } from "views/Dashboards/CourseAnalysisDashboard/Common";
import { ParticipationListPublicationPeriod } from "views/Dashboards/UserAndGroupsDashboard/Common";
import PublicationCommentsDialog from "views/Publication/Dialogs/PublicationCommentsDialog";

/////////////////////////////////////////////////////////////////////////////////////

type GraphProps = IDashboardCourseAnalysisGraphProps & WithTranslation;

export class DashboardCourseAnalysisSocialGraph extends React.PureComponent<GraphProps, IDashboardCourseAnalysisGraphState>{

    constructor(props: GraphProps) {
        super(props);

        this.state = {
            data: null,
            loading: true,
            selectedDay: null,
            tabOption: DashboardCourseAnalysisGraphPeriod.Last30
        };
    }

    ///
    private getDateFilter() {

        var de = moment().utc().endOf("day");
        var ds = moment().utc().startOf("day");
        ds.add(-30, "days");

        return { startDate: ds.toDate(), endDate: de.toDate() };
    }

    ///
    private loadData() {

        api.getDashboardCourseAnalysis({
            columnToSummary: this.props.tile,
            detailColumn: DashboardCourseAnalysisDetailColumn.GraphByDay,
            ...this.getDateFilter(),
            ...this.props.filter,
            range: null,
        })
            .then((result) => {
                (result as DashboardGraphModel[]).forEach((v) => {
                    v.day = v.day.convertLocalToUtcDate();
                });

                this.setState({ data: (result as DashboardGraphModel[]), loading: false });
            })
            .catch((error) => {
                this.setState({ data: null, loading: false });
            });
    }

    ///
    private checkForUpdateState(prevProps: GraphProps) {
        if (!LibUtils.isEqual(this.props.filter, prevProps.filter)) {
            this.loadData();
        }
        else if (this.props.tile != prevProps.tile) {
            this.setState({ selectedDay: null, tabOption: DashboardCourseAnalysisGraphPeriod.Last30 }, () => this.loadData());
        }
    }

    ///
    public componentDidMount() {
        this.loadData();
    }

    ///
    public componentDidUpdate(prevProps: GraphProps) {
        this.checkForUpdateState(prevProps);
    }

    ///
    public render() {
        const { tile } = this.props;
        const { data, loading } = this.state;

        if (loading)
            return <SpinnerIndicator />;

        if (data == null)
            return <AppMessageBox resource="LoadGraphDataFailed" />;

        var title = tile == DashboardCourseAnalysisSummaryColumn.Comments
            ? this.props.t("Views.Dashboards.CourseAnalysis.SocialGraph.CommentsTitle")
            : tile == DashboardCourseAnalysisSummaryColumn.Likes
                ? this.props.t("Views.Dashboards.CourseAnalysis.SocialGraph.LikesTitle")
                : null;

        return (
            <>
                <MuiContainer margin="dense" >
                    <Grid container justifyContent="space-between">
                        <Grid item>
                            <Typography component="p" variant="h6"><b>{title.toString().toLocaleUpperCase()}</b></Typography>
                            <MuiMuted>
                                <small>
                                    <RenderGraphGmtInfo />
                                </small>
                            </MuiMuted>
                        </Grid>
                    </Grid>
                </MuiContainer>

                <RenderLineGraph color="blue" data={this.state.data} onSelectDay={(dt) => this.setState({ selectedDay: dt })} />

                <DashboardCourseAnalysisSocialList
                    {...this.props}
                    tile={tile}
                    selectedDay={this.state.selectedDay}
                    graphPeriod={this.state.tabOption}
                    onCancelDay={() => this.setState({ selectedDay: null })}
                />

            </>
        );
    }
}

/////////////////////////////////////////////////////////////////////////////////////////////

interface IListState {
    dialog: any;
    data: PagedResult<any>;
    offset: number;
    loading: boolean;
    tabOption: DashboardCourseAnalysisListPeriod;
}

type ListProps = IDashboardCourseAnalysisListProps & WithTranslation;

export class DashboardCourseAnalysisSocialList extends React.PureComponent<ListProps, IListState> {

    constructor(props: ListProps) {
        super(props);

        this.state = {
            dialog: null,
            data: null,
            offset: null,
            loading: true,
            tabOption: DashboardCourseAnalysisListPeriod.Last30
        };
    }
    ///
    private res(r: string) {
        return this.props.t("Views.Dashboards.CourseAnalysis.SocialList." + r);
    }

    ///
    private loadData(offset: number, scrollToStartOfList: boolean = false) {

        this.setState({ loading: true });

        api.getDashboardCourseAnalysis(
            {
                columnToSummary: this.props.tile,
                detailColumn: DashboardCourseAnalysisDetailColumn.Courses,
                range: { offset, take: DefaultListParameters.viewRecordsByPage },
                ...this.getDateFilter(),
                ...this.props.filter
            })
            .then((result) => {
                this.setState({ data: result, loading: false, offset: offset }, () => {
                    if (scrollToStartOfList) HtmlUtils.scrollToElement("divList");
                });
            })
            .catch((error) => {
                this.setState({ data: null, loading: false, offset: 0 });
            });
    }

    ///
    private handleExport = () => {

        api.getDashboardCourseAnalysis(
            {
                columnToSummary: this.props.tile,
                detailColumn: DashboardCourseAnalysisDetailColumn.Courses,
                range: { offset: 0, take: 32767 },
                ...this.getDateFilter(),
                ...this.props.filter
            })
            .then((result) => {
                const fileName = 'CourseAnalysisSocial-' + moment().toISOString();

                const csv = (result.items as DashboardPublicationModel[]).map((v) => { return { title: v.title, creationDate: v.creationDate, publishDate: v.publishDate, creatorName: v.creatorName, firstTopicName: v.firstTopicName, total: v.total }; });

                if (csv.length > 0) exportToXLSX(csv, fileName);
            })
            .catch((error) => {
                this.setState({ data: null, loading: false, offset: 0 });
            });
    };

    ///
    private getDateFilter() {

        if (this.props.selectedDay) {
            return {
                startDate: this.props.selectedDay.convertUtcToLocalDate(),
                endDate: this.props.selectedDay.putEndOfDay().convertUtcToLocalDate()
            };
        }

        if (this.state.tabOption == DashboardCourseAnalysisListPeriod.Last30) {
            var lastDay = moment().utc().endOf("day");
            var firstDay = moment().utc().startOf("day");
            firstDay.add(-30, "days");

            return {
                startDate: firstDay.toDate(),
                endDate: lastDay.toDate()
            };
        }

        return {
            startDate: null,
            endDate: null
        };
    }

    ///
    private handleCommentClick = (publicationId: string) => {
        this.setState({
            dialog: <PublicationCommentsDialog
                publicationId={publicationId}
                {...this.getDateFilter()}
                onClose={() => this.setState({ dialog: null })}
            />
        });
    };

    ///
    private drillDownUsers(publicationId: string, name: string) {
        this.setState({
            dialog: (
                <UserListDrawer
                    title={this.res("UserListDrawerTitle")}
                    subtitle={name}
                    onGetData={
                        (searchText, offset) =>
                            api.getDashboardCourseAnalysis({
                                columnToSummary: this.props.tile,
                                detailColumn: DashboardCourseAnalysisDetailColumn.CoursesDrillDown,
                                ...this.getDateFilter(),
                                ...this.props.filter,
                                drillDownFilter: {
                                    id: publicationId,
                                    title: searchText,
                                },
                                range: { offset: offset, take: 20 },
                            })
                    }
                    onClose={
                        () => this.setState({ dialog: null })
                    }
                />
            )
        });
    }

    ///
    private renderHeader() {

        const sDay = this.props.selectedDay ? moment(this.props.selectedDay).format("DD/MMM") : null;

        return (
            <div id="divList">
                <MuiContainer margin="dense" >
                    <Grid container justifyContent="space-between" alignItems="center">
                        <Grid item>
                            {
                                (this.props.tile == DashboardCourseAnalysisSummaryColumn.Likes) ? this.res("HeaderTitleLikes") : this.res("HeaderTitleComments")
                            }
                        </Grid>

                        <Grid item>
                            {
                                this.props.selectedDay
                                    ? (
                                        <MuiReverse color="warning">
                                            <b>{`${Formaters.capitalize(this.props.t("Glossary.Day"))} ${sDay}`}</b>
                                            <IconButtonCancel
                                                size="small"
                                                onClick={() => this.props.onCancelDay()}
                                            />
                                        </MuiReverse>
                                    )
                                    : (
                                        <AppTabs
                                            value={this.state.tabOption}
                                            onChange={
                                                (e, newValue: DashboardCourseAnalysisListPeriod) => {
                                                    this.setState({ tabOption: newValue }, () => this.loadData(0, true));
                                                }
                                            }
                                            indicatorColor="primary"
                                            textColor="primary"
                                        >
                                            <Tab label={this.props.t<string>("Views.Dashboards.Common.LastMonth")} value={ParticipationListPublicationPeriod.Last30} />
                                            <Tab label={this.props.t<string>("Views.Dashboards.Common.FullPeriod")} value={ParticipationListPublicationPeriod.All} />
                                        </AppTabs>
                                    )
                            }
                        </Grid>
                    </Grid>
                </MuiContainer>
            </div>
        );
    }

    ///
    private renderListBody() {
        const { data: { items }, offset } = this.state;
        const detailCountText = { plural: this.res("Views.Dashboards.Common.DetailCountView2"), singular: this.res("Views.Dashboards.Common.DetailCountView1") };

        if (this.props.tile == DashboardCourseAnalysisSummaryColumn.Likes)
            return <RenderPublicationModelList
                indexOffset={offset}
                items={items}
                detailCountText={detailCountText}
                showCreationDate={false}
                onDrillDown={(item) => this.drillDownUsers(item.publicationId, item.title)} />;

        return <RenderPublicationModelList
            indexOffset={offset}
            items={items}
            detailCountText={detailCountText}
            showCreationDate={false}
            onDrillDown={(item) => this.handleCommentClick(item.publicationId)} />;
    }

    ///
    private renderList() {
        const { data: { total }, dialog } = this.state;

        return (
            <MuiContainer margin="normal">
                <div>
                    {dialog}
                    <br />
                    {this.renderHeader()}

                    {
                        this.props.selectedDay == null && total == 0
                            ? <MuiMessageBox variant="warning" message={this.res("EmptyData")} />
                            : total == 0
                                ? <MuiMessageBox variant="warning" message={this.res("FilteredEmptyData")} />
                                : (
                                    <>
                                        <MuiContainer>
                                            <Table size="small">
                                                <TableBody>
                                                    {this.renderListBody()}
                                                </TableBody>
                                            </Table>
                                        </MuiContainer>
                                        {
                                            total > 0 &&
                                            <Grid container justifyContent="center" alignItems="center">
                                                <Grid item xs>
                                                    <MuiPagination
                                                        limit={DefaultListParameters.viewRecordsByPage}
                                                        offset={this.state.offset}
                                                        total={total}
                                                        onClick={(e, offset) => this.loadData(offset, true)}
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <IconButtonDownload onClick={this.handleExport} />
                                                </Grid>
                                            </Grid>
                                        }
                                    </>
                                )
                    }
                </div>
            </MuiContainer >
        );
    }

    ///
    public componentDidMount() {
        this.loadData(0);
    }

    ///
    public componentDidUpdate(prevProps: ListProps) {
        if (
            !LibUtils.isEqual(this.props.filter, prevProps.filter)
            ||
            (this.props.selectedDay && this.props.selectedDay != prevProps.selectedDay)
            ||
            (this.props.selectedDay == null && prevProps.selectedDay != null) || this.props.tile != prevProps.tile
        ) {
            this.loadData(0);
        }
    }

    ///
    public render() {
                return (
            <div>
                {
                    this.state.loading
                        ? <SpinnerIndicator />
                        : this.state.data == null
                            ? <AppMessageBox resource="LoadListDataFailed" />
                            : this.renderList()
                }
            </div>
        );
    }
}